import { render, staticRenderFns } from "./IsInsured.vue?vue&type=template&id=77db660c&"
import script from "./IsInsured.vue?vue&type=script&lang=js&"
export * from "./IsInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports